import type { FieldSelectProps } from "./field-select.type";

import { Form, Select } from "antd";

export const FieldSelect = ({
  name,
  label,
  options,
  placeholder,
  required,
  disabled,
  hidden,
  loading,
  rules,
  validateStatus,
  help,
  allowClear,
  className,
  variant,
  title,
  optionRender,
  labelRender,
  onChange,
  classNames,
  ...props
}: FieldSelectProps) => {
  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules ?? (required ? [{ required: true }] : undefined)}
      required={required}
      hidden={hidden}
      validateStatus={validateStatus}
      help={help}
      className={className}
    >
      <Select
        {...props}
        options={options}
        placeholder={placeholder}
        disabled={disabled}
        loading={loading}
        allowClear={allowClear}
        variant={variant}
        title={title}
        optionRender={optionRender}
        labelRender={labelRender}
        onChange={onChange}
        classNames={classNames}
      />
    </Form.Item>
  );
};
